var $16d2015735d51a41$exports = {};
$16d2015735d51a41$exports = {
    "invalidSelection": (args, formatter)=>`Selected ${formatter.plural(args.selectedCount, {
            one: `date`,
            other: `dates`
        })} unavailable.`
};


export {$16d2015735d51a41$exports as default};
//# sourceMappingURL=en-US.module.js.map
